// extracted by mini-css-extract-plugin
export default {"appDefault":"App_appDefault__oClRh","appSecondary":"App_appSecondary__ncer+","loaderContainer":"App_loaderContainer__FthOV","circular":"App_circular__26vsy"};